import {
  getCampaignId,
  getMerchantId,
  getScreenName,
} from "../reducers/methods";
import { store } from "../store";
import { StoreState } from "../reducers";
import { encodeQueryParams } from "../middleware/utils";
import { PUBLIC_API_URL } from "../config";

interface SendErrorParams {
  category: string;
  subCategory?: string;
  args?: string;
  name: string;
  payload: string;
}

export function sendError(params: SendErrorParams) {
  const storeState = store.getState() as StoreState;
  const merchantId = getMerchantId(storeState);
  const campaignId = getCampaignId(storeState);
  const screenName = getScreenName(storeState);

  if (merchantId) {
    const payload = {
      ...params,
      service: "fbt-widget-sdk",
      merchantId,
      campaignId,
      screenName,
      version: process.env.REACT_APP_CIRCLE_SHA1 || "local_dev",
    };

    const xmlHttp = new XMLHttpRequest();
    xmlHttp.open(
      "POST",
      `${PUBLIC_API_URL}/error` + encodeQueryParams(payload),
      true
    );
    xmlHttp.setRequestHeader("Content-Type", "text/plain");
    xmlHttp.send(null);
  }
}
